package com.milta.core.lifecycle

import kotlinx.browser.document
import kotlinx.coroutines.channels.awaitClose
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.callbackFlow
import org.w3c.dom.events.Event

/** Kotlin/JS — the tab becomes visible again (`visibilitychange` with `visibilityState == "visible"`). */
actual fun appForegroundEvents(): Flow<Unit> = callbackFlow {
    val listener: (Event) -> Unit = {
        if (document.asDynamic().visibilityState == "visible") trySend(Unit)
    }
    document.addEventListener("visibilitychange", listener)
    awaitClose { document.removeEventListener("visibilitychange", listener) }
}
